/*
TODO:
Form
- Deal with cursor on suffixes (Alex)
- Manufacturer drop down breaks layout (Alex)
- Setting default values to options (Tom)
- Allowing integer fields to be empty (Tom)
- Use incoterm from the schema (Tom/Stan)
*/

export const shipmentQuoteConfig = {
  ShipmentQuoteForm: {
    title: 'New Quote.',
    fields: [
      'currency',
      'validUntil',
      'manufacturer',
      'takeRate',
      'downPayment',
      'secondPaymentDue',
      'incoterm',
      'manufacturingTime',
      'bufferTime',
      'notes',
      'isOrder',
    ],
    styles: {
      // formColumns: 2,
      labelBold: true,
    },
  },
  fields: {
    takeRate: {
      label: 'Take Rate',
      placeholder: 'Take Rate in %',
      component: 'forms.TextField',
      fieldStore: 'forms.IntegerFieldStore',
      suffixValue: '%',
      minVal: 0,
      maxVal: 100,
    },
    downPayment: {
      label: 'Down Payment',
      placeholder: '50 %',
      component: 'forms.TextField',
      suffixValue: '%',
      fieldStore: 'forms.IntegerFieldStore',
      minVal: 0,
      maxVal: 100,
    },
    secondPaymentDue: {
      label: 'Second Payment Due (natural days)',
      placeholder: '',
      suffixValue: 'days',
      component: 'forms.TextField',
      fieldStore: 'forms.IntegerFieldStore',
      minVal: 0, // let's make this IntegerFieldStore capable of being empty not just '0'?
      optional: true,
    },
    incoterm: {
      label: 'Incoterms',
      component: 'forms.SelectField',
      placeholder: 'Please select',
      labelKey: 'label',
      appKey: 'value',
      options: {
        default: 'exw',
        values: [
          {
            label: 'EXW',
            value: 'EXW',
          },
          {
            label: 'FOB',
            value: 'FOB',
          },
          {
            label: 'FAS',
            value: 'FAS',
          },
          {
            label: 'FCA',
            value: 'FCA',
          },
          {
            label: 'CFR',
            value: 'CFR',
          },
          {
            label: 'CPT',
            value: 'CPT',
          },
          {
            label: 'CIF',
            value: 'CIF',
          },
          {
            label: 'DAP',
            value: 'DAP',
          },
          {
            label: 'DDP',
            value: 'DDP',
          },
          {
            label: 'CIP',
            value: 'CIP',
          },
          {
            label: 'DAT',
            value: 'DAT',
          },
          {
            label: 'DDU',
            value: 'DDU',
          },
        ],
      },
    },
    manufacturingTime: {
      label: 'Manufacturing Time (business days)',
      placeholder: 'e.g. 10',
      suffixValue: 'days',
      component: 'forms.TextField',
      fieldStore: 'forms.IntegerFieldStore',
      minVal: 1,
      maxVal: 1000,
    },
    bufferTime: {
      label: 'Buffer Time (business days)',
      placeholder: 'e.g. 2',
      suffixValue: 'days',
      component: 'forms.TextField',
      fieldStore: 'forms.IntegerFieldStore',
      minVal: 1,
      maxVal: 1000,
    },
    manufacturer: {
      type: 'manufacturer',
    },
    validUntil: {
      label: 'Valid Until',
      placeholder: 'DD / MM / YYYY',
      component: 'forms.DateField',
      optional: true,
      validator: 'futureDate',
    },
    currency: {
      label: 'Currency',
      component: 'forms.SelectField',
      placeholder: 'Please select',
      unclearable: true,
      labelKey: 'label',
      appKey: 'value',
      options: {
        default: 'EUR',
        values: [
          {
            label: 'US Dollars',
            value: 'USD',
          },
          {
            label: 'Euros',
            value: 'EUR',
          },
          {
            label: 'Pound Sterling',
            value: 'GBP',
          },
        ],
      },
    },
    notes: {
      label: 'Additional Notes',
      placeholder:
        'Please specify any additional notes that go beyond our default terms here',
      component: 'forms.TextAreaField',
      optional: true,
      noValidation: true,
    },
    isOrder: {
      label: 'Create Quote as Paid Order?',
      fieldStore: 'forms.BoolFieldStore',
      component: 'forms.CheckboxField',
      optional: true,
      descriptionChecked: 'Create a quote that’s already paid',
      descriptionUnChecked: 'Just a normal quote',
    },
  },
};
